module.exports = __webpack_public_path__ + "img/card-bg-image-demo-1.36390f4b.jpg";